import { FC, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslations } from '@altermaind/core/i18n';
import { Banner } from '@/_shared/components/Banner';
import { useDialog } from '@/_shared/hooks';
import { useLayoutBanner } from '@/_shared/hooks/useLayoutBanner';
import type { DialogContactsPayload } from '@/core/components/DialogContacts/DialogContacts';
import { getUserWarningsCall } from '@/core/state/api/getUserWarningsCall';

const BANNER_KEY = 'banner.betaExpiring';

export const BetaExpiringBanner: FC = () => {
  const t = useTranslations('billing.betaExpiringBanner');
  const { setBanner } = useLayoutBanner();
  const { isBetaExpiring } = getUserWarningsCall.hook();
  const { openDialog: openContacts } = useDialog<DialogContactsPayload>('contacts');
  const [isDismissed, setIsDismissed] = useState(false);

  const cta = useMemo(
    () => ({
      label: t('cta'),
      onClick: () => openContacts({}),
    }),
    [t, openContacts],
  );

  const onClose = useCallback(() => {
    setIsDismissed(true);
    setBanner(BANNER_KEY, null);
  }, [setBanner]);

  useEffect(() => {
    if (!isBetaExpiring || isDismissed) {
      setBanner(BANNER_KEY, null);
      return;
    }

    setBanner(
      BANNER_KEY,
      <Banner
        message={t('message', { expiringDate: isBetaExpiring.expiringDate })}
        cta={cta}
        type='warning'
        iconName='warning'
        onClose={onClose}
      />,
    );
  }, [isBetaExpiring, isDismissed, cta, onClose, t, setBanner]);

  return null;
};
